<style lang="scss">
@import "./styles/contact-assignation.scss";
</style>

<template>
  <v-layout class="contact-assignation" row wrap>
    <v-flex xs12 md6>
      <ContactStack
        class="contact-stack-left-margin"
        :isCompanyOrganization="isCompanyOrganization"
        :contact-category="directorContactCategory"
        :title="this.$t('$company.organization.directors')"
        :are-cards-removable="areCardsRemovable"
        :contacts="directors"
        :contacts-topic="contactsTopic"
        :on-boarding-topic="onBoardingTopic"
      >
        <template slot="add-button">
          <AddContactPopover
            :text="this.$t('$company.organization.add_director')"
            :contacts-topic="contactsTopic"
            :existing-contacts="contacts"
            :contact-category="directorContactCategory"
            :director="true"
            :on-boarding-topic="onBoardingTopic"
            :show-main-point-of-contact="showMainPointOfContact"
          />
        </template>
      </ContactStack>
    </v-flex>
    <v-flex xs12 md6>
      <ContactStack
        class="contact-stack-right-margin"
        :isCompanyOrganization="isCompanyOrganization"
        :contact-category="shareholderContactCategory"
        :title="this.$t('$company.organization.shareholders')"
        :contacts="shareholders"
        :are-cards-removable="areCardsRemovable"
        :contacts-topic="contactsTopic"
        :on-boarding-topic="onBoardingTopic"
      >
        <template slot="add-button">
          <AddContactPopover
            :text="this.$t('$company.organization.add_shareholder')"
            :contacts-topic="contactsTopic"
            :existing-contacts="contacts"
            :contact-category="shareholderContactCategory"
            :shareholder="true"
            :on-boarding-topic="onBoardingTopic"
          />
        </template>
      </ContactStack>
    </v-flex>
    <v-flex xs12 md6>
      <ContactStack
        v-if="standardUsers"
        class="contact-stack-left-margin"
        :isCompanyOrganization="false"
        :contact-category="standardUserContactCategory"
        :title="this.$t('$company.organization.standard_users')"
        :contacts="standardUsers"
        :are-cards-removable="areCardsRemovable"
        :contacts-topic="contactsTopic"
        :on-boarding-topic="onBoardingTopic"
      >
        <template slot="add-button">
          <AddContactPopover
            v-if="isCurrentUserOwner"
            :text="this.$t('$company.organization.add_standard_user')"
            :contacts-topic="contactsTopic"
            :existing-contacts="contacts"
            :contact-category="standardUserContactCategory"
            :standardUser="true"
            :on-boarding-topic="onBoardingTopic"
            :show-invitation-send="true"
          />
        </template>
      </ContactStack>
    </v-flex>
  </v-layout>
</template>

<script>
// Components
import ContactStack from "./ContactStack.vue";
import AddContactPopover from "./AddContactPopover.vue";

// Constants
import { Constants } from "customer-sdk/constants";
const CONTACT_CATEGORIES = Constants.CONTACT_CATEGORIES;

export default {
  name: "ContactAssignation",
  components: {
    ContactStack,
    AddContactPopover
  },
  props: {
    onBoardingTopic: Object,
    contactsTopic: Object,
    contacts: Array,
    directors: Array,
    standardUsers: Array,
    shareholders: Array,
    is1YearDirectorActive: Boolean,
    is6MonthsDirectorActive: Boolean,
    is3MonthsDirectorActive: Boolean,
    isCompanyOrganization: Boolean,
    isCurrentUserOwner: Boolean,
    showMainPointOfContact: Boolean,
    areCardsRemovable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      shareholderContactCategory: CONTACT_CATEGORIES.SHAREHOLDER,
      directorContactCategory: CONTACT_CATEGORIES.DIRECTOR,
      standardUserContactCategory: CONTACT_CATEGORIES.STANDARD_USER
    };
  }
};
</script>
